PF.List.Search = class Search extends PF.Trait
	{
	initTrait()
		{
		this.dom.searchToggle.show();
		this.searchString = new PF.Field.String({
			dom: {
				element: this.dom.search
			},
			key: 'value',
			model: new PF.Model({raw: {value: ''}}),
			label: this.searchLabel,
			showInfo: false
		});

		this.calc('searchField', 'searchString.model.value');
		// this.models.filter.and(`${this.search} ~ @{list.searchString.model.value}`);
		this.models.filter.and(this.searchConfig);

		this.searchShow = false;
		this.dom.searchToggle.on('click', () => this.searchShow = !this.searchShow);
		this.bindDom({searchToggle: 'class:active', titleRow: 'class:search-show'}, 'searchShow');
		this.onValue('searchShow', true, () => this.searchString.setFocus());
		this.onValue('searchShow', false, () => this.searchString.model.setData('value', ''));
		}
	};